'use client'

import React, { useState } from 'react'
import { useRouter } from 'next/navigation'
import { parseUrl } from '@hashicorp/react-components/src/lib/parse-url'
import Form from '@hashicorp/react-components/src/components/marketo-form'
import type { MarketoFormAPIResponse } from '@hashicorp/react-components/src/components/marketo-form/types'
import s from './style.module.css'

type WebinarRegistrationFormProps = {
	webinarId: string
	product: string[]
	title: string
	marketoForm: MarketoFormAPIResponse
	destinationUrl?: string
}

export default function RegistrationForm({
	webinarId,
	product,
	title,
	marketoForm,
	destinationUrl,
}: WebinarRegistrationFormProps) {
	const [globalError, setGlobalError] = useState(null)
	const router = useRouter()
	const successUrl = destinationUrl
		? parseUrl(destinationUrl).href
		: '/thank-you/webinar'

	return (
		<>
			<h4 className={`g-type-display-4 ${s.heading}`}>
				Register for the live webinar
			</h4>
			<Form
				{...marketoForm}
				initialValues={{ registeredWebinarID: webinarId }}
				onSubmitSuccess={() => {
					if (window && window.analytics) {
						window.analytics.track('Webinar Signed Up', {
							...(product?.length && { product: product[0] }),
							title: title,
							webinar_id: webinarId,
							sales_contact_requested: false,
						})
					}

					router.push(successUrl)
				}}
				onSubmitError={() => {
					setGlobalError(
						'Unfortunately something went wrong. Please try again later.'
					)
				}}
			/>
			{globalError && (
				<div className="global-error g-type-body-small error">
					{globalError}
				</div>
			)}
		</>
	)
}
